<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-12">
				<b-card>
					<div slot="header">
						<strong>{{ $t('Main Info') }}</strong>
					</div>
					<b-alert variant="danger" dismissible :show="!!msg_error">
						<button type="button" aria-label="Close" class="close" @click="msg_error = false">×</button>
						<div v-html="msg_error"></div>
					</b-alert>
					<form id="container__form" @submit.prevent="save">
						<tooltip label="connection name" placement="right">
							<input
								name="name"
								v-model="record.name"
								v-validate="'required'"

								:class="{'form-control': true, 'is-invalid': errors.has('name')}"
								type="text"
							/>
							<span v-show="errors.has('name')" class="help invalid-feedback">
								{{ $t(errors.first('name')) }}
							</span>
						</tooltip>

						<tooltip label="Database Driver" placement="right">
							<select
								name="driver"
								v-model="record.driver"
								:class="{'form-control': true, 'is-invalid': errors.has('driver')}"
								v-validate="'required'"

							>
								<option value="" disabled="">{{ $t('Choose Driver') }}</option>
								<option
									v-for="driver in $store.state.sql_support_drivers"
									v-if="!driver.disabled"
									:value="driver.value"
								>
									{{ driver.label }}
								</option>
							</select>
							<span v-show="errors.has('driver')" class="help invalid-feedback">
								{{ $t(errors.first('driver')) }}
							</span>
						</tooltip>

						<tooltip label="host" placement="right">
							<input
								name="host"
								v-model="record.host"
								v-validate="'required'"

								:class="{'form-control': true, 'is-invalid': errors.has('host')}"
								type="text"
							/>
							<span v-show="errors.has('host')" class="help invalid-feedback">
								{{ $t(errors.first('host')) }}
							</span>
						</tooltip>

						<tooltip
							label="port"
							placement="right"
							v-if="
								record.driver == 'MS_SQL_SERVER' ||
									record.driver == 'ORACLE' ||
									record.driver == 'POSTGRE_SQL'
							"
						>
							<input
								name="port"
								v-model="record.port"
								v-validate="'required|integer'"

								:class="{'form-control': true, 'is-invalid': errors.has('port')}"
								type="text"
							/>
							<span v-show="errors.has('port')" class="help invalid-feedback">
								{{ $t(errors.first('port')) }}
							</span>
						</tooltip>

						<tooltip label="db_or_service_name" placement="right">
							<input
								name="dbname"
								v-model="record.dbname"
								v-validate="'required'"

								:class="{'form-control': true, 'is-invalid': errors.has('dbname')}"
								type="text"
							/>
							<span v-show="errors.has('dbname')" class="help invalid-feedback">
								{{ $t(errors.first('dbname')) }}
							</span>
						</tooltip>

						<tooltip label="username" placement="right">
							<input
								name="username"
								v-model="record.username"
								v-validate="'required'"

								:class="{'form-control': true, 'is-invalid': errors.has('username')}"
								type="text"
							/>
							<span v-show="errors.has('username')" class="help invalid-feedback">
								{{ $t(errors.first('username')) }}
							</span>
						</tooltip>

						<tooltip label="password" placement="right">
							<input
								name="password"
								v-model="record.password"
								v-validate="''"

								:class="{'form-control': true, 'is-invalid': errors.has('password')}"
								type="password"
							/>
							<span v-show="errors.has('password')" class="help invalid-feedback">
								{{ $t(errors.first('password')) }}
							</span>
						</tooltip>

						<tooltip label="sid" placement="right" v-if="record.driver == 'ORACLE'">
							<input
								name="sid"
								v-model="record.sid"
								v-validate="''"

								:class="{'form-control': true, 'is-invalid': errors.has('sid')}"
								type="text"
							/>
							<span v-show="errors.has('sid')" class="help invalid-feedback">
								{{ $t(errors.first('sid')) }}
							</span>
						</tooltip>
					</form>
				</b-card>
			</div>
			<!-- /.col -->
			<ButtonSubmit />
		</div>
	</div>
</template>
<script>
import axios from 'axios'

import {ButtonSubmit} from '../../components'
export default {
	name: 'datasourceForm',
	components: {
		ButtonSubmit,
	},
	data() {
		return {
			record_id: 0,
			msg_error: false,
			record: {
				name: '',
				driver: '',
				dbname: '',
				host: '',
				username: '',
				password: '',
				port: '',
				sid: '',
			},
		}
	},
	methods: {
		save(e) {
			e.preventDefault()
			this.msg_error = false
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.$root.loader = true
					axios
						.post('/data_sources/save/' + this.record_id, this.record)
						.then((response) => {
							this.$root.loader = false
							if (response.data.status === 1) {
								this.$store.commit('update_breadcrumb_history', {
									mode: 'datasources',
									id: response.data.data.data_source_id,
									change_to: response.data.data.entity.name,
								})
								this.$router.push('/datasources/' + response.data.data.data_source_id)
							} else {
								this.msg_error = response.data.msg
							}
						})
				} else {
					// invalid
					this.$root.loader = false
				}
			})
		},
	},
	mounted() {
		// console.log(this.$store.state.sql_support_drivers)
		if (parseInt(this.$route.params.id) >= 1) {
			this.record_id = parseInt(this.$route.params.id)
			this.$root.loader = true
			axios.get('/data_sources/browse/' + this.record_id).then((response) => {
				if (response.data.status == 1) {
					this.record = Object.assign(this.record, response.data.data.entity)
				}
				this.$root.loader = false
			})
		}
	},
}
</script>
